var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignupWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342,
    height: 230,
    viewBox: "0 0 342 230",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 1,
    x2: 0.043,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef1eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f5f9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7996",
    "data-name": "Rectangle 7996",
    width: 342,
    height: 230,
    transform: "translate(20 -64)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.27,
    y1: 0.132,
    x2: 0.429,
    y2: 0.395,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe8be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fba324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc7d47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9d72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd66b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_257",
    x: 206.334,
    y: 106.978,
    width: 80.153,
    height: 80.153,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fba324",
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e64ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5edfff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1496",
    x: 170.675,
    y: 123.865,
    width: 23.058,
    height: 23.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1498",
    x: 253.206,
    y: 196.915,
    width: 23.058,
    height: 23.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7998",
    x: 237.045,
    y: 30.338,
    width: 23.058,
    height: 23.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7997",
    x: 296.793,
    y: 140.172,
    width: 23.058,
    height: 23.058,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0b203f",
    floodOpacity: 0.22
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5e62"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0,
    y2: 1,
    xlinkHref: "#linear-gradient-8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(-271 -434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_13_8",
    "data-name": "Component 13 \\u2013 8",
    transform: "translate(271 434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-20 64)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36964",
    "data-name": "Group 36964",
    transform: "translate(-4.121 -73.598)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    cx: 259,
    cy: 225.5,
    rx: 259,
    ry: 225.5,
    transform: "translate(24 10.331)",
    opacity: 0.25,
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36987",
    "data-name": "Group 36987",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 526.672, 190.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36964-2",
    "data-name": "Group 36964",
    transform: "matrix(0.799, -0.602, 0.602, 0.799, -3.981, 153.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 69.01, 413.49)",
    filter: "url(#Ellipse_257)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_257-2",
    "data-name": "Ellipse 257",
    cx: 22.485,
    cy: 22.485,
    rx: 22.485,
    ry: 22.485,
    transform: "translate(274.49 127.13) rotate(107)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    cx: 132.298,
    cy: 40.012,
    rx: 132.298,
    ry: 40.012,
    transform: "translate(0 96.436)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_264-2",
    "data-name": "Ellipse 264",
    cx: 40.012,
    cy: 132.298,
    rx: 40.012,
    ry: 132.298,
    transform: "matrix(0.899, 0.438, -0.438, 0.899, 154.33, 0)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_264-3",
    "data-name": "Ellipse 264",
    cx: 132.298,
    cy: 40.012,
    rx: 132.298,
    ry: 40.012,
    transform: "translate(67.042 14.607) rotate(45)",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 69.01, 413.49)",
    filter: "url(#Rectangle_1496)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496-2",
    "data-name": "Rectangle 1496",
    width: 6.454,
    height: 6.454,
    rx: 3,
    transform: "translate(186.23 131.25) rotate(107)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 69.01, 413.49)",
    filter: "url(#Rectangle_1498)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1498-2",
    "data-name": "Rectangle 1498",
    width: 6.454,
    height: 6.454,
    rx: 3,
    transform: "translate(268.76 204.3) rotate(107)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 69.01, 413.49)",
    filter: "url(#Rectangle_7998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7998-2",
    "data-name": "Rectangle 7998",
    width: 6.454,
    height: 6.454,
    rx: 3,
    transform: "translate(252.6 37.72) rotate(107)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.29, -0.96, 0.96, -0.29, 69.01, 413.49)",
    filter: "url(#Rectangle_7997)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7997-2",
    "data-name": "Rectangle 7997",
    width: 6.454,
    height: 6.454,
    rx: 3,
    transform: "translate(312.35 147.56) rotate(107)",
    fill: "url(#linear-gradient-4)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38318",
    "data-name": "Group 38318",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 222.593, 246.049)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_290",
    "data-name": "Ellipse 290",
    cx: 21,
    cy: 20.5,
    rx: 21,
    ry: 20.5,
    transform: "translate(-0.154 0.126)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38313",
    "data-name": "Group 38313",
    transform: "translate(5.208 7.924)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81303",
    "data-name": "Path 81303",
    d: "M14.063,28.362,0,20.392V17.111H4.219V6.8L0,5.391V0H28.362V5.391L24.611,6.8v9.141l2.578,1.172,1.172,3.281Z",
    transform: "translate(1.406 0.943)",
    fill: "#fde8d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-e-Colleges_Icon",
    "data-name": "-e-Colleges Icon",
    d: "M1.289,0H29.651a1.289,1.289,0,0,1,1.289,1.289V6.446a1.289,1.289,0,0,1-1.289,1.289H27.072V16.76h2.579a1.289,1.289,0,0,1,1.289,1.289v3.868a1.288,1.288,0,0,1-.644,1.135L16.114,30.787a1.289,1.289,0,0,1-1.238,0L.7,23.052A1.287,1.287,0,0,1,0,21.917V18.05A1.289,1.289,0,0,1,1.289,16.76H3.867V7.735H1.289A1.289,1.289,0,0,1,0,6.446V1.289A1.289,1.289,0,0,1,1.289,0ZM2.578,21.15,15.47,28.183,28.361,21.15V19.339H2.578Zm0-15.993H28.361V2.579H2.578Zm3.868,11.6H24.493V7.735H6.445Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38319",
    "data-name": "Group 38319",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 259.286, 138.118)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_292",
    "data-name": "Ellipse 292",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(-0.4 0.012)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38312",
    "data-name": "Group 38312",
    transform: "translate(5.6 6.012)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8010",
    "data-name": "Rectangle 8010",
    width: 8.438,
    height: 5.625,
    transform: "translate(10.781 21.562)",
    fill: "#fddbbd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8011",
    "data-name": "Rectangle 8011",
    width: 24.375,
    height: 21.096,
    transform: "translate(2.812 2.813)",
    fill: "#fddbbd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_-e-Exams_Icon",
    "data-name": "-e-Exams Icon",
    d: "M4.5,30A4.529,4.529,0,0,1,0,25.445V9.106A4.527,4.527,0,0,1,4.5,4.553H9A4.527,4.527,0,0,1,13.5,0h3A4.526,4.526,0,0,1,21,4.553h4.5A4.526,4.526,0,0,1,30,9.106V25.445A4.528,4.528,0,0,1,25.5,30ZM3,9.106V25.445a1.509,1.509,0,0,0,1.5,1.518h21A1.509,1.509,0,0,0,27,25.445V9.106a1.51,1.51,0,0,0-1.5-1.518H21V9.106a1.508,1.508,0,0,1-1.5,1.518h-9A1.508,1.508,0,0,1,9,9.106V7.589H4.5A1.511,1.511,0,0,0,3,9.106Zm9-4.553V7.589h6V4.553a1.509,1.509,0,0,0-1.5-1.518h-3A1.508,1.508,0,0,0,12,4.553ZM7.5,22.409a1.518,1.518,0,0,1,0-3.036h9a1.518,1.518,0,0,1,0,3.036Zm0-5.714a1.518,1.518,0,0,1,0-3.035h15a1.518,1.518,0,0,1,0,3.035Z",
    transform: "translate(30 30) rotate(180)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38320",
    "data-name": "Group 38320",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 98.475, 176.06)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_291",
    "data-name": "Ellipse 291",
    cx: 21,
    cy: 21.5,
    rx: 21,
    ry: 21.5,
    transform: "translate(0.397 -0.206)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38310",
    "data-name": "Group 38310",
    transform: "translate(6.123 7.064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38311",
    "data-name": "Group 38311",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81300",
    "data-name": "Path 81300",
    d: "M1.034,0c.9.4,1.729.743,2.535,1.125a1.817,1.817,0,0,0,1.505.035,8.933,8.933,0,0,1,9.132,1.487c.116.095.222.2.377.342-.433.05-.815.087-1.2.137A13.661,13.661,0,0,0,9.02,4.452a1.212,1.212,0,1,0,1.065,2.17,11.74,11.74,0,0,1,8.607-.708c.386.11.761.261,1.134.408A1.361,1.361,0,0,0,20.935,6.3c1.3-.582,2.613-1.154,3.921-1.729.043-.019.089-.033.193-.072-.05.143-.079.242-.118.338-.4.988-.781,1.984-1.2,2.963a1.4,1.4,0,0,0,.249,1.59,8.869,8.869,0,0,1,2.12,6.018,9.058,9.058,0,0,1-3.227,6.778,11.159,11.159,0,0,1-9.107,2.725,10.806,10.806,0,0,1-7-3.674,9.037,9.037,0,0,1-.91-10.806,1.382,1.382,0,0,0,.276-1.048,1.2,1.2,0,0,0-2.191-.447A11.511,11.511,0,0,0,2.3,12.9c-.021.1-.044.2-.081.364-.251-.288-.485-.53-.69-.793A6.96,6.96,0,0,1,1.6,3.682a1.462,1.462,0,0,0,.251-1.671C1.567,1.381,1.327.731,1.034,0m9.726,17.721a4.536,4.536,0,1,0,9.063.3A1.2,1.2,0,0,0,18.15,16.9a1.228,1.228,0,0,0-.752,1.2,2.111,2.111,0,1,1-4.17-.54,2.2,2.2,0,0,1,1.314-1.547,3.285,3.285,0,0,0,1.952-3.175,1.193,1.193,0,0,0-1.15-1.176,1.172,1.172,0,0,0-1.246,1.1,1.262,1.262,0,0,1-.821,1.2,4.363,4.363,0,0,0-2.518,3.763m4.6-7.517a1.209,1.209,0,1,0-1.217-1.2,1.21,1.21,0,0,0,1.217,1.2",
    transform: "translate(2.416 3.502)",
    fill: "#fcd8bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81298",
    "data-name": "Path 81298",
    d: "M0,1.431V.948A1.3,1.3,0,0,1,1.957.186C3.476.9,5.024,1.553,6.564,2.222a.635.635,0,0,0,.421.031A11.337,11.337,0,0,1,12.4,1.729a10.763,10.763,0,0,1,7.731,4.8.68.68,0,0,0,.35.232q1.009.3,2.031.567a.8.8,0,0,0,.475-.019c2.048-.891,4.087-1.8,6.131-2.692a1.686,1.686,0,0,1,.547-.151,1.2,1.2,0,0,1,1.156,1.7Q29.777,8.8,28.7,11.427a.532.532,0,0,0,.07.594,11.41,11.41,0,0,1,.143,13.194,13.093,13.093,0,0,1-8.6,5.484c-.56.108-1.13.162-1.7.242H16.8a1.6,1.6,0,0,0-.232-.05,12.5,12.5,0,0,1-4.068-.936c-4.386-1.868-7.206-5.022-7.932-9.847a.775.775,0,0,0-.357-.57A9.8,9.8,0,0,1,.276,13.852C.155,13.366.091,12.868,0,12.376V10.864a.5.5,0,0,0,.043-.112,9.425,9.425,0,0,1,1.71-4.608.376.376,0,0,0,.027-.3C1.192,4.371.6,2.9,0,1.431M3.447,3.5c.3.731.533,1.383.817,2.011a1.461,1.461,0,0,1-.249,1.671,6.965,6.965,0,0,0-.073,8.793c.207.263.439.5.69.791.039-.168.062-.265.081-.364a11.505,11.505,0,0,1,1.641-3.964,1.2,1.2,0,0,1,2.189.445,1.378,1.378,0,0,1-.276,1.05,9.038,9.038,0,0,0,.912,10.8,10.784,10.784,0,0,0,7,3.674,11.156,11.156,0,0,0,9.107-2.723,9.049,9.049,0,0,0,3.227-6.78,8.876,8.876,0,0,0-2.12-6.018,1.406,1.406,0,0,1-.249-1.588c.421-.98.8-1.974,1.2-2.964.039-.095.07-.2.12-.338-.1.039-.151.054-.2.073-1.306.574-2.616,1.145-3.919,1.727a1.365,1.365,0,0,1-1.111.021c-.373-.147-.748-.3-1.134-.408a11.735,11.735,0,0,0-8.6.71,1.212,1.212,0,1,1-1.067-2.17A13.626,13.626,0,0,1,15.8,6.627c.381-.048.763-.087,1.2-.135-.155-.141-.259-.249-.377-.342A8.929,8.929,0,0,0,7.488,4.661a1.82,1.82,0,0,1-1.5-.033C5.179,4.243,4.354,3.9,3.447,3.5",
    stroke: "#ff5e62",
    strokeWidth: 0.3,
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81301",
    "data-name": "Path 81301",
    d: "M0,6.065A4.36,4.36,0,0,1,2.518,2.3a1.253,1.253,0,0,0,.819-1.2A1.173,1.173,0,0,1,4.586,0,1.192,1.192,0,0,1,5.733,1.179a3.283,3.283,0,0,1-1.95,3.175A2.194,2.194,0,0,0,2.47,5.9a2.111,2.111,0,1,0,4.17.54,1.226,1.226,0,0,1,.75-1.2,1.2,1.2,0,0,1,1.671,1.12,4.551,4.551,0,0,1-3.7,4.452A4.6,4.6,0,0,1,0,6.065",
    transform: "translate(13.175 15.158)",
    fill: "#ff5e62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81302",
    "data-name": "Path 81302",
    d: "M1.217,2.417A1.209,1.209,0,1,1,2.415,1.2a1.211,1.211,0,0,1-1.2,1.218",
    transform: "translate(16.558 11.29)",
    fill: "#ff5e62"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38321",
    "data-name": "Group 38321",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 151.171, 218.384)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_289",
    "data-name": "Ellipse 289",
    cx: 21.5,
    cy: 21,
    rx: 21.5,
    ry: 21,
    transform: "translate(-0.112 -0.473)",
    fill: "rgba(255,255,255,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_38315",
    "data-name": "Group 38315",
    transform: "translate(6.119 8.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38316",
    "data-name": "Group 38316",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_81304",
    "data-name": "Path 81304",
    d: "M26.786,20.858c.3,0,.6,0,.9.007a1.958,1.958,0,0,1,.758.153,1.3,1.3,0,0,1,.716,1.468,1.364,1.364,0,0,1-1.4,1.069H2.821a1.349,1.349,0,1,1-.044-2.692c.305-.007.61-.007.916,0h.084l-.771-1.842Q1.659,15.789.292,12.569a3.5,3.5,0,0,1-.255-1.928,5.759,5.759,0,0,1,2.51-3.958A5.689,5.689,0,0,1,7.1,5.838a5.68,5.68,0,0,1,4.389,4.437,3.074,3.074,0,0,1-.06,2q-1.489,3.519-2.96,7.049l-.637,1.52h6.1V2.7H9.717a3.085,3.085,0,0,1-.484-.032A1.32,1.32,0,0,1,8.117,1.408,1.321,1.321,0,0,1,8.475.43,1.5,1.5,0,0,1,9.576,0H21.039a1.72,1.72,0,0,1,.242.014,1.342,1.342,0,0,1,1.163,1.335,1.313,1.313,0,0,1-1.173,1.323,3.328,3.328,0,0,1-.443.024H16.64V20.842h6.1l-.748-1.786c-.9-2.159-1.8-4.32-2.724-6.472a3.535,3.535,0,0,1-.24-2.022,5.82,5.82,0,0,1,5.7-4.884h.055a5.8,5.8,0,0,1,5.445,3.839,8.29,8.29,0,0,1,.249.887l.091.374.018.942ZM21.205.536Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81305",
    "data-name": "Path 81305",
    d: "M0,0,3.242,7.742,6.485,0Z",
    transform: "translate(21.522 12.348)",
    fill: "#fcefe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81306",
    "data-name": "Path 81306",
    d: "M0,0C1.08,2.579,2.148,5.129,3.24,7.742L6.482,0Z",
    transform: "translate(2.557 12.349)",
    fill: "#fcefe2"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupWeb);
export default __webpack_public_path__ + "static/media/signup_web.87e37dd0870dc3e52115326eaa91cf75.svg";
export { ForwardRef as ReactComponent };